import { t } from 'i18next';
import React from 'react';

import { UChips } from 'Components/unit';
import { getTranslatedLabel } from 'Services/language/languageService';
import { Audience } from 'Store/entities/activity/activity.type';

import styles from '../Item.styles';

interface TargetAudienceProps {
  audience: Audience;
}

const TargetAudience: React.FC<TargetAudienceProps> = ({ audience }) => {
  switch (audience.mode) {
    case 'all':
      return <>{t('activities:list.item.audience.empty_segments_label')}</>;
    case 'groups': {
      const groupNames = audience.groupNames || [];
      if (groupNames.length > 4) {
        return (
          <>
            {groupNames.slice(0, 3).map((name) => (
              <UChips key={name} value={name} type="standard" />
            ))}
            <UChips
              value="others"
              type="aggregated"
              aggregateItems={groupNames.slice(3).map((name) => ({
                value: name,
                isCloseVisible: false,
              }))}
            />
          </>
        );
      }
      return (
        <>
          {groupNames.map((name) => (
            <UChips key={name} value={name} type="standard" />
          ))}
        </>
      );
    }
    case 'magic-code':
      return (
        <>
          {t('activities:list.item.audience.magic_code')}
          <span style={styles.magicCode}>{audience.code}</span>
        </>
      );
    case 'email-list':
      return <>{t('activities:list.item.audience.email_list')}</>;
    case 'audience':
      return (
        <>
          {t('activities:list.item.audience.campaign')}
          <span style={styles.magicCode}>{audience.campaignName && getTranslatedLabel(audience.campaignName)}</span>
        </>
      );
    case 'none':
      return <>{t('activities:list.item.audience.no_target_mode')}</>;
    default:
      return null;
  }
};

export default TargetAudience;
